export default __webpack_public_path__ + "assets/images/a76e03df4971f26ebc1b7b5e5110dcda.png";